import { dialog } from "../../../nq-component";
import BaseListPresenter from "../../../base/BaseListPresenter";
import saveAs from "../../../saveAs";
import {
  deleteObjectUseCase,
  updateObjectUseCase,
} from "../../../usecases/object";
import { getCurrentUserUseCase } from "../../../usecases/user";
import { setDragLock } from "framer-motion";
import { liveQueryUseCase } from "../../../usecases/livequery";

class JobListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    exportCSVUseCase,
    addSchemaUseCase,
    updateSchemaUseCase,
    deleteSchemaUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.exportCSVUseCase = exportCSVUseCase;
    this.addSchemaUseCase = addSchemaUseCase;
    this.updateSchemaUseCase = updateSchemaUseCase;
    this.deleteSchemaUseCase = deleteSchemaUseCase;
  }

  componentDidMount() {
    const token = this.view.getToken();
    this.init();
    // this.subscribe();
    this.getUser(token);
    return this.getObjects();
  }

  init() {
    this.limit = 20;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.include = ["employee"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  onClickAdd() {
    const collection = this.view.getCollectionName();
    this.view.navigateTo("/admin/employee/form");
  }

  async onClickEdit(objects) {
    const collection = this.view.getCollectionName();
    const query = {
      where: { id: objects[0].id },
    };
    const response = await this.findObjectUseCase.execute(collection, query);

    if (response && response.length > 0) {
      const object = response[0];

      this.view.setState(
        {
          formData: {
            id: object?.id,
            positionTitle: object?.positionTitle || {},
            slotVacancy: object?.slotVacancy || "",
            qualificationStandard: object?.qualificationStandard || "",
            jobDescription: object?.jobDescription || "",
            deadline: object?.deadline || "",
          },
        },
        () => {
          this.view.onClickAdd(object);
        },
      );
    }
  }

  async onClickDelete(empDetails) {
    dialog.close();
    const object = empDetails;
    const collection = this.view.getCollectionName();

    await deleteObjectUseCase().execute(collection, object.id);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }

  async handleSubmit(formData) {
    dialog.close();
    const collection = this.view.getCollectionName();
    const acl = this.view.getAcl();
    let sendDetails = {};
    if (formData.id !== "") {
      const { password, ...formDataWithoutId } = formData;
      sendDetails = { ...formDataWithoutId };
    } else {
      const { id, ...formDataWithoutId } = formData;
      sendDetails = { ...formDataWithoutId, status: "Active" };
    }

    sendDetails.acl = acl;

    await this.upsertUseCase.execute(collection, sendDetails);
    this.view.setObjects(this.objects);
    this.reset();
    this.getObjects();
  }

  async getUser(token) {
    const options = { session: token };

    try {
      const user = await getCurrentUserUseCase().execute(options);
      if (user && typeof user === "object") {
        this.user = user;
      } else {
        throw new Error("Invalid response structure");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
      this.view.navigateTo("/expired");
    }
  }

  validatePassword(newPassword, confirmNewPassword) {
    if (newPassword !== confirmNewPassword) {
      return "Password must be the same.";
    }

    if (newPassword.length < 8 || newPassword.length > 16) {
      return "Password length must be 8-16 characters.";
    }

    const validation =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&])(?=.*\d)[A-Za-z\d@$!%*?&]+$/;

    if (!validation.test(newPassword)) {
      return "Password must contain at least one uppercase letter, one lowercase letter, one special character, and one number.";
    }

    return null;
  }

  onSubmitPassword(password) {
    dialog.close();
    const user = this.user;
    const { newPassword, confirmNewPassword } = password;

    const errorMessage = this.validatePassword(newPassword, confirmNewPassword);

    if (errorMessage) {
      this.view.showError(errorMessage);
      return;
    }

    user.password = newPassword;
    this.updateUser(user);
  }

  updateUser(user) {
    this.view.showProgress();
    delete user.isMaster;

    updateObjectUseCase()
      .execute("users", user)
      .then((user) => {
        this.view.hideProgress();
        this.user = user;
        this.view.showSuccess("Successfully saved!");
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }
}

export default JobListPresenter;
